<template>
	<EventLayout :event="event" :subtitle="trans(`events.packs.enrollments.${enrollmentStatus}.subtitle`)" :return-url="route('events.packs.edit', [event.id, pack.id])" :return-label="pack.name">
		<Pagination :resource="enrollments"/>
		<CardGrid>
			<Card v-for="enrollment in enrollments.data" :title="enrollment.user.full_name">
				<template #footer>
					<a :href="route('events.enrollments.show', [event.id, enrollment.id])" target="_blank">
						<SecondaryButton :color="Color.Blue">
							<i class="fa-solid fa-edit mr-2"/>
							{{ trans('general.edit') }}
						</SecondaryButton>
					</a>
					<a :href="route('events.enrollments.purchase-orders.index', {event: event.id, status: enrollmentStatus === EnrollmentStatus.Pending ? enrollmentStatus : 'accepted', user_id: enrollment.user_id})" target="_blank">
						<SecondaryButton :color="Color.Purple">
							<i class="fa-solid fa-edit mr-2"/>
							{{ trans('enrollments.purchase_orders.title') }}
						</SecondaryButton>
					</a>
				</template>
			</Card>
		</CardGrid>
		<Pagination :resource="enrollments"/>
	</EventLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {defineProps} from 'vue'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {type Event} from '@/Types/Events/Event'
import Card from '@/Components/UI/Cards/Card.vue'
import {type Pack} from '@/Types/Events/Packs/Pack'
import EventLayout from '@/Layouts/EventLayout.vue'
import Pagination from '@/Components/UI/Pagination.vue'
import {type Enrollment} from '@/Types/Events/Enrollment'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import {EnrollmentStatus} from '@/Types/Enums/EnrollmentStatus'
import {type PaginatedModel} from '@/Types/Pagination/PaginatedModel'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'

defineProps<{
	pack:Pack,
	event:Event,
	enrollmentStatus:string,
	enrollments:PaginatedModel<Enrollment>,
}>()
</script>